import React from 'react';
import { Link } from 'react-router-dom';
import { HandCoins } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../../components/page-header/Header';

// Placeholder until online donations exist. (This page used to show a mock-up
// with made-up campaigns and donors, and buttons that did nothing.)
const DonationsDashboard = () => {
    const { t } = useTranslation();

    const breadcrumbItems = [
        { label: t("universal_dashboard_text"), to: '/user-dashboard' },
        { label: t("donations_breadcurmbs_title", "Donations") },
    ];

    return (
        <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
            <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-5">
                <Header title={t("donations_title", "Donations")} breadcrumbItems={breadcrumbItems} />

                <div className="bg-white rounded-xl shadow-md p-8 sm:p-12 flex flex-col items-center text-center">
                    <div className="bg-emerald-50 p-4 rounded-full mb-4">
                        <HandCoins className="w-10 h-10 text-emerald-600" />
                    </div>
                    <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Coming soon</h2>
                    <p className="text-gray-600 max-w-lg">
                        Online donations, campaigns, Gift Aid and donation QR codes are on their way.
                        Until then you can add your own donation link (for example LaunchGood or JustGiving) to your website.
                    </p>
                    <Link to="/user-dashboard/masjid-web" className="mt-5 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700">
                        Open the website editor
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default DonationsDashboard;
